export const theme = {
    colors: {
        background: '#ffffff',
        surface: 'rgba(51, 51, 51, 0.05)',
        surfaceStrong: '#f3f5f7',
        surfaceMuted: '#f7f8fa',
        text: 'rgba(51, 51, 51, 0.8)',
        textStrong: '#333333',
        textSoft: 'rgba(51, 51, 51, 0.5)',
        line: 'rgba(227, 232, 238, 0.5)',
        dividerStrong: '#e3e8ee',
        purple: '#5115f1',
        purpleSoft: '#f3eeff',
        danger: '#b64040',
        dangerBg: '#fff3f3',
        emptyThumb: '#e8e8e8',
        overlayHover: 'rgba(51, 51, 51, 0.05)',
        overlaySubtle: 'rgba(51, 51, 51, 0.03)',
        overlayStrong: 'rgba(51, 51, 51, 0.07)',
        attachedBg: 'rgba(81, 21, 241, 0.08)',
        attachedBadgeBg: 'rgba(81, 21, 241, 0.12)',
        focusRing: 'rgba(81, 21, 241, 0.08)',
        focusLine: 'rgba(81, 21, 241, 0.25)',
    },
    shadows: {
        floating: '0 10px 30px rgba(19, 23, 28, 0.08)',
        filterButton: '0 2px 10px rgba(51, 51, 51, 0.3)',
        filterPanel: '0 2px 20px rgba(51, 51, 51, 0.3)',
        auth: '0 16px 40px rgba(24, 24, 24, 0.1)',
    },
    radii: {
        xl: '24px',
        lg: '16px',
        md: '14px',
        sm: '12px',
    },
    gradients: {
        barcelona: 'linear-gradient(135deg, #2a3146 0%, #886d45 100%)',
        lisbon: 'linear-gradient(135deg, #3e1912 0%, #8e2a20 52%, #1d1d1d 100%)',
        'new-york': 'linear-gradient(135deg, #80631a 0%, #ce9b33 46%, #2e4e36 100%)',
        paris: 'linear-gradient(135deg, #16253e 0%, #1d4675 58%, #6f8ead 100%)',
        london: 'linear-gradient(135deg, #5a4a35 0%, #8b6f4b 54%, #d1b083 100%)',
        riga: 'linear-gradient(135deg, #9f5521 0%, #d98d4e 50%, #f0c18c 100%)',
    },
} as const

export type TaskpaneTheme = typeof theme
